import React, { useEffect, useState } from 'react';
import { useNotify } from 'react-admin';
import { apiGet, apiPost } from '../../brainApi';
import EmailNotificationRender from './EmailNotificationRender';
import SmsNotificationRender from './SmsNotificationRender';
import { sendAnalyticsEvent } from '../../analytics';

export const NotificationEmail = ({ record }) => {
  const notify = useNotify();
  const scheduledWorkId = record.scheduled_work_id;
  const hasEmail = !!record.customer.email;
  const [postmarkTemplates, setPostmarkTemplates] = useState({});
  const [currentPostmarkTemplate, setCurrentPostmarkTemplate] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [sendTo, setSendTo] = useState({sendToUser: 'customer'});
  const fetchEmailTemplates = () => {
    const params = { list_type: 'sw' };
    apiGet('/postmark/template', params).then((templates) => {
      setPostmarkTemplates(templates);

      if (templates && Object.keys(templates).length) {
        // Set state to be the id (index 0) of the first entry in the template list
        setCurrentPostmarkTemplate(Object.keys(templates)[0]);
      }
    });
  };

  useEffect(fetchEmailTemplates, []);

  const sendToMail = (event) => {
    const name = event.target.name;
    setSendTo({
      ...sendTo,
      [name] : event.target.value,
    });
  } 

  const sendEmail = (event, isTest = false) => {
    event.preventDefault();
    if(sendTo.sendToUser === 'customer'){
      isTest = false;
    }else if(sendTo.sendToUser === 'admin'){
      isTest = true;
    }
    const url = `/scheduled-work/${scheduledWorkId}/send-email/${currentPostmarkTemplate}`;
    return apiPost(url, { send_as_test: !!isTest }).then((json) => {
      if (json.Status === 'Failure') {
        notify(`Error: ${json.Message}`, 'warning');
      } else {
        setSnackbarOpen(true);
        sendAnalyticsEvent('emailSent', {
          template: currentPostmarkTemplate,
          send_as_test: !!isTest,
        });
      }
    });
  };

  return (
    <EmailNotificationRender
      snackbarOpen={snackbarOpen}
      setSnackbarOpen={setSnackbarOpen}
      currentPostmarkTemplate={currentPostmarkTemplate}
      setCurrentPostmarkTemplate={setCurrentPostmarkTemplate}
      postmarkTemplates={postmarkTemplates}
      sendEmail={sendEmail}
      hasEmail={hasEmail}
      sendToMail = {sendToMail}
      sendTo={sendTo}
    />
  );
};

export const NotificationSms = ({ record }) => {
  const notify = useNotify();
  const scheduledWorkId = record.scheduled_work_id;
  const [smsTemplates, setSmsTemplates] = useState([]);
  const [currentSmsTemplate, setCurrentSmsTemplate] = useState('');
  const [smsContent, setSmsContent] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [smsIsSending, setSmsIsSending] = useState(false);

  const getSmsContent = (template) => {
    setSmsContent('');
    return apiGet(`/scheduled-work/${scheduledWorkId}/sms/${template}`).then(
      (json) => {
        if (json.Status === 'Failure') {
          notify(`Error: ${json.Message}`, 'warning');
        } else {
          setSmsContent(json.Body);
        }
      },
    );
  };

  const fetchSMSTemplates = () => {
    const params = { list_type: 'sw' };
    apiGet('/mustache/template', params).then((templates) => {
      templates.sort((a, b) => {
        if (!a) {
          return b;
        }
        if (!b) {
          return a;
        }
        return a.title.localeCompare(b.title);
      });

      setSmsTemplates(templates);

      if (templates && templates.length) {
        setCurrentSmsTemplate(templates[0].filename);
        getSmsContent(templates[0].filename);
      }
    });
  };

  // useEffect is the hook most similar to componentDidMount
  useEffect(fetchSMSTemplates, []);

  const setSmsTemplateAndContent = (event) => {
    setCurrentSmsTemplate(event.target.value);
    getSmsContent(event.target.value);
  };

  const sendSms = (event) => {
    setSmsIsSending(true);
    event.preventDefault();
    const url = `/scheduled-work/${scheduledWorkId}/sms/${currentSmsTemplate}`;
    apiPost(url)
      .then((json) => {
        setSmsIsSending(false);
        if (json.Status === 'Failure') {
          notify(`Error: ${json.Message}`, 'warning');
        } else {
          setSnackbarOpen(true);
          sendAnalyticsEvent('messageSent', {
            template: currentSmsTemplate,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        setSmsIsSending(false);
        notify('Error: Message failed to send', 'warning');
      });
  };

  return (
    <SmsNotificationRender
      snackbarOpen={snackbarOpen}
      setSnackbarOpen={setSnackbarOpen}
      smsTemplates={smsTemplates}
      currentSmsTemplate={currentSmsTemplate}
      setSmsTemplateAndContent={setSmsTemplateAndContent}
      smsContent={smsContent}
      sendSms={sendSms}
      smsIsSending={smsIsSending}
    />
  );
};
